/* eslint-disable no-useless-escape */
export const PURPOSE_OF_PAYMENT_REGEX = /^[ A-Za-z0-9.'+:,/()\-]*$/;

export const COMPANY_NAME_REGEX = /^[ A-Za-z0-9.'+:,/()\-]*$/;
export const FIRST_NAME_REGEX = /^[ A-Za-z0-9.'+:,/()\-]*$/;

export const BENEFICIARY_ADDRESS_REGEX = /^[ A-Za-z0-9.'+:,/()\-]*$/;
export const BANK_ACCOUNT_NO_REGEX = /^[A-Za-z0-9]*$/;
export const BANK_CODE_REGEX = /^[A-Za-z0-9-]*$/;
export const BANK_NAME_REGEX = /^[ A-Za-z()]*$/;
